module.exports = __webpack_public_path__ + "img/pic_1.2055fe78.jpg";